import { DynamicLegalPage } from "./DynamicLegalPage";
import { useTranslation } from "react-i18next";

/**
 * Kept for backward compatibility. The actual content is now stored in the
 * `legal_pages` table (slug `mentions-legales`) and editable from the admin.
 * Falls back to i18n strings while loading or if the row is missing.
 */
export function LegalPage() {
  const { t } = useTranslation();
  const sections = (() => {
    const v = t("legal.page.sections", { returnObjects: true });
    return Array.isArray(v) ? (v as Array<{ title: string; body: string }>) : [];
  })();
  return (
    <DynamicLegalPage
      slug="mentions-legales"
      fallback={{
        eyebrow: t("legal.page.eyebrow"),
        title: t("legal.page.title"),
        intro: t("legal.page.intro"),
        sections,
      }}
    />
  );
}
